import { SinglePackage } from "../models/project";

export function updatePackage(
  obj,
  targetKey,
  targetValue,
  nodes,
  childPackages
) {
  if (obj?.hasOwnProperty(targetKey)) {
    const localObj = { ...obj };
    if (obj[targetKey] === targetValue) {
      // return;
      if (nodes) {
        const x = nodes.map((n) => {
          let no = {
            id: n.id,
            position: n.position,
            type: n.type,
            height: n.height,
            width: n.width,
            parentNode: n.parentNode,
            data: {
              ...n.data,
              customData: n.data?.customData || {},
            },
          };

          return no;
        });
        localObj.components = x;
      } else if (childPackages) localObj.childrenPackages = childPackages;
      return localObj;
    }

    const pkgs = localObj.childrenPackages?.map((p) => {
      return updatePackage(p, targetKey, targetValue, nodes, childPackages);
    });
    localObj.childrenPackages = [...pkgs];
    return localObj;
  }
}

// Helper function to get package data from Redux state
export function getPackageFromRedux(basePackage: SinglePackage, packageName: string): SinglePackage | null {
  if (basePackage?.packageName === packageName) {
    return basePackage;
  }
  
  if (basePackage?.childrenPackages && basePackage.childrenPackages.length > 0) {
    for (const child of basePackage.childrenPackages) {
      const found = getPackageFromRedux(child, packageName);
      if (found) return found;
    }
  }
  
  return null;
}

export const deepSearchForPackage = (pkg: SinglePackage, pkgName) => {
  if (pkg?.hasOwnProperty("packageName")) {
    if (pkg.packageName === pkgName) return pkg;
    for (let i = 0; i < pkg.childrenPackages.length; i++) {
      const search = deepSearchForPackage(pkg.childrenPackages[i], pkgName);
      if (search) return search;
    }
    return null;
  }
};
